@switch (model.size) {
  @case (1) {
    <section [class.size1]="true"> </section>
  }
  @case (2) {
    <section [class.size2]="true"> </section>
  }
  @case (3) {
    <section [class.size3]="true"> </section>
  }
  @case (4) {
    <section [class.size4]="true"> </section>
  }
  @case (5) {
    <section [class.size5]="true"> </section>
  }
}